export const REPORTS_REQUEST = 'REPORTS_REQUEST'
export function reportsRequest(filters) {
    return {
        type: REPORTS_REQUEST,
        filters
    }
}

export const FETCH_MORE_REPORTS = 'FETCH_MORE_REPORTS'
export function fetchMoreReports(filters) {
    return {
        type: FETCH_MORE_REPORTS,
        filters
    }
}

export const REPORTS_REQUEST_MORE_SUCCESS = 'REPORTS_REQUEST_MORE_SUCCESS'
export function reportsRequestMoreSuccess(reports) {
    return {
        type: REPORTS_REQUEST_MORE_SUCCESS,
        reports
    }
}

export const REPORTS_REQUEST_MORE_ERROR = 'REPORTS_REQUEST_MORE_ERROR'
export function reportsRequestMoreError() {
    return {
        type: REPORTS_REQUEST_MORE_ERROR
    }
}

export const REPORTS_REQUEST_SUCCESS = 'REPORTS_REQUEST_SUCCESS'
export function reportsRequestSuccess(reports) {
    return {
        type: REPORTS_REQUEST_SUCCESS,
        reports
    }
}

export const REPORTS_REQUEST_ERROR = 'REPORTS_REQUEST_ERROR'
export function reportsRequestError() {
    return {
        type: REPORTS_REQUEST_ERROR
    }
}

export const REPORT_REQUEST = 'REPORT_REQUEST'
export function reportRequest(reportId) {
    return {
        type: REPORT_REQUEST,
        reportId
    }
}

export const REPORT_REQUEST_SUCCESS = 'REPORT_REQUEST_SUCCESS'
export function reportRequestSuccess(report) {
    return {
        type: REPORT_REQUEST_SUCCESS,
        report
    }
}

export const REPORT_SHARING_HISTORY_REQUEST = 'REPORT_SHARING_HISTORY_REQUEST'
export function reportSharingHistoryRequest(reportId) {
    return {
        type: REPORT_SHARING_HISTORY_REQUEST,
        reportId
    }
}

export const REPORT_SHARING_HISTORY_REQUEST_SUCCESS =
    'REPORT_SHARING_HISTORY_REQUEST_SUCCESS'
export function reportSharingHistoryRequestSuccess(reportSharingHistory) {
    return {
        type: REPORT_SHARING_HISTORY_REQUEST_SUCCESS,
        reportSharingHistory
    }
}

export const REPORT_SHARING_HISTORY_REQUEST_ERROR =
    'REPORT_SHARING_HISTORY_REQUEST_ERROR'
export function reportSharingHistoryRequestError() {
    return {
        type: REPORT_SHARING_HISTORY_REQUEST_ERROR
    }
}

export const REPORT_REQUEST_ERROR = 'REPORT_REQUEST_ERROR'
export function reportRequestError() {
    return {
        type: REPORT_REQUEST_ERROR
    }
}

export const COMMENT_POST_REQUEST = 'COMMENT_POST_REQUEST'
export function postComment(data) {
    return {
        type: COMMENT_POST_REQUEST,
        data
    }
}

export const COMMENT_POST_REQUEST_SUCCESS = 'COMMENT_POST_REQUEST_SUCCESS'
export function commentPostSuccess(data) {
    return {
        type: COMMENT_POST_REQUEST_SUCCESS,
        data
    }
}

export const COMMENT_POST_REQUEST_ERROR = 'COMMENT_POST_REQUEST_ERROR'
export function commentPostError() {
    return {
        type: COMMENT_POST_REQUEST_ERROR
    }
}

export const COMMENT_DELETE_REQUEST = 'COMMENT_DELETE_REQUEST'
export function deleteComment(data) {
    return {
        type: COMMENT_DELETE_REQUEST,
        data
    }
}

export const COMMENT_DELETE_REQUEST_SUCCESS = 'COMMENT_DELETE_REQUEST_SUCCESS'
export function deleteCommentSuccess(data) {
    return {
        type: COMMENT_DELETE_REQUEST_SUCCESS,
        data
    }
}

export const COMMENT_DELETE_REQUEST_ERROR = 'COMMENT_DELETE_REQUEST_ERROR'
export function deleteCommentError() {
    return {
        type: COMMENT_DELETE_REQUEST_ERROR
    }
}

export const COMMENT_EDIT_REQUEST = 'COMMENT_EDIT_REQUEST'
export function editComment(data) {
    return {
        type: COMMENT_EDIT_REQUEST,
        data
    }
}

export const COMMENT_EDIT_REQUEST_SUCCESS = 'COMMENT_EDIT_REQUEST_SUCCESS'
export function editCommentSuccess(data) {
    return {
        type: COMMENT_EDIT_REQUEST_SUCCESS,
        data
    }
}

export const COMMENT_EDIT_REQUEST_ERROR = 'COMMENT_EDIT_REQUEST_ERROR'
export function editCommentError() {
    return {
        type: COMMENT_EDIT_REQUEST_ERROR
    }
}

export const COMMENT_REQUEST = 'COMMENT_REQUEST'
export function requestComment(comments) {
    return {
        type: COMMENT_REQUEST,
        comments
    }
}

export const COMMENT_REQUEST_SUCCESS = 'COMMENT_REQUEST_SUCCESS'
export function requestCommentSuccess(comments) {
    return {
        type: COMMENT_REQUEST_SUCCESS,
        comments
    }
}

export const GET_IMAGES_FROM_COMMENT_BY_COMMENT_ID =
    'GET_IMAGES_FROM_COMMENT_BY_COMMENT_ID'
export function getImagesFromCommentById(commentId) {
    return {
        type: GET_IMAGES_FROM_COMMENT_BY_COMMENT_ID,
        commentId
    }
}

export const SET_IMAGES_FOR_COMMENTS = 'SET_IMAGES_FOR_COMMENTS'
export function setImagesForComments(images) {
    return {
        type: SET_IMAGES_FOR_COMMENTS,
        images
    }
}

export const DELETE_IMAGES_FROM_COMMENT = 'DELETE_IMAGES_FROM_COMMENT'
export function deleteCommentImages(image) {
    return {
        type: DELETE_IMAGES_FROM_COMMENT,
        image
    }
}

export const COMMENT_REQUEST_ERROR = 'COMMENT_REQUEST_ERROR'
export function requestCommentError() {
    return {
        type: COMMENT_REQUEST_ERROR
    }
}

export const COMMENT_IMAGES_LOADER = 'COMMENT_IMAGES_LOADER'
export function setCommentImagesLoader(loading) {
    return {
        type: COMMENT_IMAGES_LOADER,
        loading
    }
}
